export { defaultWagmiConfig } from '../../src/utils/defaultWagmiReactConfig.js';
//# sourceMappingURL=config.js.map